import { render } from "./RiskLegend.vue?vue&type=template&id=73325e19"
import script from "./RiskLegend.vue?vue&type=script&lang=js"
export * from "./RiskLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__